import { Link } from "@material-ui/core";
import { useState , useEffect} from "react";
import Autosuggest from "react-autosuggest";

import { Form, FormControl, InputGroup } from "react-bootstrap";

import "./search.css";

export default function Search({ suggestions, setInput, handleSearch , pre_value}) {

  const [value, setValue] = useState(pre_value || "");;
  const [suggestionsList, setSuggestions] = useState([]);

  useEffect(() => {
    // Set the input value when the component is mounted
    if (pre_value) {
      setValue(pre_value);
      setInput(pre_value);
    }
  }, [pre_value, setInput]);


  const getSuggestions = (inputValue) => {
    const inputValueLowerCase = inputValue.toLowerCase();
    return suggestions.filter((suggestion) =>
      suggestion.toLowerCase().includes(inputValueLowerCase)
    );
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSuggestionSelected = (_, { suggestion }) => {
    setInput(suggestion);
  };

  const onChange = (_, { newValue }) => {
    setInput(newValue);
    setValue(newValue);
  };

  const inputProps = {
    placeholder: "Search",
    value,
    onChange
  };

  const renderSuggestion = (suggestion) => {
    return (
      <div className="d-flex justify-content-between align-items-center p-1">
        <span>{suggestion}</span>
      </div>
    );
  };

  
  console.log("check11",pre_value )
  console.log("check22", value)

  return (
    <Form
      className="input-group search-engine w-100"
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
    >
      <Autosuggest
        containerProps={{
          className: "w-100"
        }}
        suggestions={suggestionsList}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={(suggestion) => suggestion}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        renderInputComponent={(inputProps) => (
          <InputGroup>
            <FormControl {...inputProps} />
            <div className="input-group-prepend">
              <Link
                to="#"
                className="btn btn-primary text-light"
                id="basic-addon1"
                onClick={handleSearch}
              >
                <i
                  className="fa fa-search fa-fw p-0"
                  aria-hidden="true"
                ></i>
              </Link>
            </div>
          </InputGroup>
        )}
      />
    </Form>
  );
}
